<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
  overflow-y: hidden;
}
#app::-webkit-scrollbar {
  width: 0;
  background: #999;
}
#app::-webkit-scrollbar-track {
  width: 0;
  background: #999;
}
#app::-webkit-scrollbar-thumb {
  width: 0;
  background: #999;
}
#app::-webkit-scrollbar-thumb:hover {
  width: 0;
  background: #999;
}
#app::-webkit-scrollbar-corner {
  width: 0;
  background: #999;
}
</style>
